module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LSO BY")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDIA")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DGHILL")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Wisdom’s Daughter: A Novel of Solomon and Sheba")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para1a"
  }, [_c('em', [_vm._v("Queenmaker: A Novel of King David’s Queen")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para1a"
  }, [_c('em', [_vm._v("File M for Murder: A Cornelia Upshaw and Fancy Mystery")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dfe612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0